import { render } from "./PasswordChangeCompletePage.vue?vue&type=template&id=04c2478d"
import script from "./PasswordChangeCompletePage.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeCompletePage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "04c2478d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04c2478d', script)) {
    api.reload('04c2478d', script)
  }
  
  module.hot.accept("./PasswordChangeCompletePage.vue?vue&type=template&id=04c2478d", () => {
    api.rerender('04c2478d', render)
  })

}

script.__file = "src/views/passwordChange/PasswordChangeCompletePage.vue"

export default script